import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'organization_signature';

export default {
  async create(body) {
    const url = mountUrl(`/${BASE_PATH}/create`);
    return api.post(url, body);
  },
  async getInvoices() {
    const url = mountUrl(`/${BASE_PATH}/invoices`);
    return api.get(url);
  }
};
